import { z } from 'zod';
import { match } from 'ts-pattern';
import type { Message } from '~~/models/Localization';

export default defineNuxtPlugin({
	name: 'zod-translations',
	dependsOn: ['i18n:plugin'],
	setup() {
		z.config({
			customError: (issue) => match(issue)
				.returnType<Message>()
				.with({ code: 'invalid_type', input: undefined }, () => 'validation.error.required')
				.with({ code: 'invalid_value', input: undefined }, () => 'validation.error.required')
				.with({ code: 'invalid_union', input: undefined }, () => 'validation.error.required')
				.with({ code: 'invalid_type', expected: 'date' }, () => 'validation.error.invalid.date')
				.with({ code: 'invalid_type', expected: 'int' }, () => 'validation.error.number.noFloat')
				.with({ code: 'invalid_format', format: 'url' }, () => 'validation.error.invalid.url')
				.with({ code: 'invalid_format', format: 'email' }, () => 'validation.error.email')
				.with({ code: 'too_small' }, () => 'validation.error.tooSmall.array')
				.with({ code: 'too_big', origin: 'number' }, () => 'validation.error.tooBig.number')
				.otherwise(() => 'validation.error.default'),
		});
	},
});
